export enum FundTypeFormat {
  DirectInvestmentFund = 'directInvestmentFund',
  FundOfFunds = 'fundOfFunds',
  SatelliteVehicle = 'satelliteVehicle',
}

export type DeadlineFrequency = 'monthly' | 'quarterly' | 'semi-annual' | 'annual';

export interface DeadlineRule {
  id: string;
  reportName: string;
  regulator: string;
  frequency: DeadlineFrequency;
  computeDeadline: (periodEnd: Date, fundType?: FundTypeFormat) => Date;
}

export interface UpcomingDeadlineResolved {
  rule: DeadlineRule;
  periodEnd: Date;
  deadline: Date;
  daysLeft: number;
  isFoF: boolean;
}
